module.exports = __webpack_public_path__ + "img/gbt5633_1_4.prt.cb5aa9f9.jpg";